import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Separator } from '../../../common/separator'
import { upperCaseFirstLetter } from '../../../helpers/common'
import { formatText } from '../../../helpers/value'
import { selectCompanyInfo } from '../store/slice'
import { COMPANY_STATUS_COLOR } from './constant'
import classes from './index.module.scss'

export const Company = () => {
  const companyInfo = useSelector(selectCompanyInfo)

  return (
    <>
      <Element className="fw600" style={{ fontSize: 24, color: '#0553A5' }}>
        {companyInfo.organizationName}
      </Element>

      <Element
        className="dFlex alignItemsCenter gap1"
        style={{ color: '#3A414B', marginTop: 2 }}
      >
        <Element
          className={classes.statusTag}
          style={{
            backgroundColor: COMPANY_STATUS_COLOR[companyInfo.activeStatusId],
            color: '#FFFFFF',
            fontSize: 10,
          }}
        >
          {companyInfo.activeStatusName}
        </Element>
        <div>{upperCaseFirstLetter(companyInfo.listingStatusName)}</div>
        <Separator
          backgroundColor="#9c9c9c"
          width={1}
          height={16}
          margin={'0 8px'}
        />
        <div>
          <Translate
            value="companyAnalysis.common.MAIN_BUSINESS"
            className="fw600"
          />
          &nbsp;
          <span>{formatText(companyInfo.vsicName)}</span>
        </div>
      </Element>

      <div className="dFlex gap5 mt1">
        <div className="flexColumn fw600" style={{ color: '#3A414B', gap: 2 }}>
          <Translate value="companyAnalysis.common.TAX_CODE" />
          <Translate value="companyAnalysis.common.TICKER_SYMBOL" />
          <Translate value="companyAnalysis.common.VIETNAMESE_NAME" />
          <Translate value="companyAnalysis.common.SHORT_NAME" />
        </div>
        <div className="flexColumn" style={{ color: '#191D25', gap: 2 }}>
          <div>{formatText(companyInfo.taxCode)}</div>
          <div>{formatText(companyInfo.ticker)}</div>
          <div>{formatText(companyInfo.organizationNameAlternate)}</div>
          <div>{formatText(companyInfo.organizationShortName)}</div>
        </div>
      </div>
    </>
  )
}
